<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="document_type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('document_type')">
                            <parameter-selectbox :validate-error="errors[0]" code="prep_student_document_types" v-model="formData.document_type"></parameter-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="file" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('excuse_file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="formData.file" :placeholder="formData.file_name || $t('select_file')"
                                             ref="fileInput"></b-form-file>
                                <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{
                                        $t('browse') }}</b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="start_date" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('excuse_start_date')">
                            <select-date v-model="formData.start_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="end_date" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('excuse_end_date')">
                            <select-date v-model="formData.end_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox :validate-error="errors[0]" code="prep_student_document_statuses" v-model="formData.status"></parameter-selectbox>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6" v-if="formData.status == 'rejected'">
                    <ValidationProvider name="description" :rules="formData.status == 'rejected' ? 'required' : ''" v-slot="{valid, errors}">
                        <b-form-group :label="$t('description')">
                            <b-form-textarea no-resize rows="4" class="h-80 h-auto-sm" maxlength="100"
                                             v-model="formData.description"></b-form-textarea>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import PrepStudentDocumentService from "@/services/PrepStudentDocumentService";
    //Components
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            ParameterSelectbox,
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                formData: {
                    document_type: null,
                    file: null,
                    file_name: null,
                    start_date: null,
                    end_date: null,
                    status: null,
                    description: null
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                PrepStudentDocumentService.get(id)
                               .then((response) => {
                                   const data = response.data.data;
                                   this.formData = {
                                       ...data,
                                       file: null,
                                       file_name: data.file?.file_name || data.file?.name,
                                       status: data.status != null && data.status != 'null' ? data.status : ''
                                   };
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;

                    const formData = new FormData();
                    formData.append("document_type", this.formData.document_type);
                    formData.append("start_date", this.formData.start_date);
                    formData.append("end_date", this.formData.end_date);
                    formData.append("status", this.formData.status);

                    if (this.formData.file && this.formData.file.length > 0) {
                        formData.append('file', this.formData.file)
                    }

                    if (this.formData.description) {
                        formData.append('description', this.formData.description)
                    }

                    PrepStudentDocumentService.update(this.formId, formData)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            },
            handleSelection(user) {
                this.formData.student_program_id = user?.student_program_id;
            },
        }
    }
</script>
